import { FC, useEffect, useState, Suspense, lazy } from 'react';
// import ReactApexChart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';
const ReactApexChart = lazy(() => import("react-apexcharts"));
interface DataItem {
  name?: string | null;
  count?: number | null;
}

interface BarGraphProps {
  data?: DataItem[];
  isLoading?: boolean;
  name?: string
}

interface GraphState {
  series: ApexOptions['series'];
  options: ApexOptions;
}

const STATUS_COLORS = [
  '#FACC15',
  '#22C55E',
  '#EF4444',
  '#4B5563',
  '#15803D',
  '#3B82F6',
  '#F97316',
  '#8B5CF6',
  '#86EFAC',
  '#FB923C',
  '#A16207',
  '#06B6D4',
  '#10B981',
  '#B91C1C',
];

const BarGraph: FC<BarGraphProps> = ({ data = [], isLoading = false, name = 'Orders' }) => {
  const [graph, setGraph] = useState<GraphState>({
    series: [],
    options: {
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 5,
          distributed: true,
        },
      },
      xaxis: {
        type: 'category',
        categories: [],
        labels: {
          rotate: -45,
          style: { fontSize: '12px' },
        },
      },
      fill: { opacity: 1 },
      tooltip: {
        y: { formatter: (val: number) => `${val}` },
      },
      colors: [],
      legend: { show: false },
    },
  });

  useEffect(() => {
    if (!data || data.length === 0) return;

    const categories = data.map((d) => d?.name || '');
    const counts = data.map((d) =>
      typeof d?.count === 'number' ? d.count : 0,
    );

    const barColors = data.map((_, i) => STATUS_COLORS[i] || '#9CA3AF');

    const newSeries = [
      {
        name: name,
        data: counts,
      },
    ];

    setGraph((prev) => ({
      ...prev,
      series: newSeries as ApexOptions['series'],
      options: {
        ...prev.options,
        xaxis: { ...prev.options.xaxis, categories },
        colors: barColors,
      },
    }));
  }, [data]);

  return (
    <div id="chart" className="w-full">
      {isLoading ? (
        <div className="flex justify-center items-center h-48">
          <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary-500 border-t-transparent"></div>
        </div>
      ) : (
        <Suspense
          fallback={<div className="h-48 flex items-center justify-center">Loading chart…</div>}
        >
          <ReactApexChart
            options={graph.options}
            series={graph.series}
            type="bar"
            height={350}
          />
        </Suspense>
      )}
    </div>
  );
};

export default BarGraph;
